// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/svg/Previous.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/svg/next.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-loader {
  display: flex;
  width: 100%;
  height: 75vh;
  align-items: center;
  justify-content: center;
}

.add-product-container * {
  box-sizing: revert-layer;
}

.add-product-container .add-prod-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-product-container .add-prod-heading p {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.add-product-container .add-prod-heading p svg {
  width: 0.7em;
}

.new_product_data form .new-product-wrapper .image-container {
  margin: 0;
  position: absolute;
  transform: translateY(-12.5%);
  left: -45px;
  width: max-content;
}

.productsList {
  position: relative;
}
.productsList ul {
  width: 100%;
  position: absolute;
  display: block;
  border: 1px solid;
  border-radius: 4px;
  padding: 0.7vw 0;
  background: #fff;
  top: -1.11vw;
  left: 0;
  max-height: 25vh;
  overflow-y: scroll;
}
.productsList ul li {
  padding: 2px 10px;
  font-size: 0.8325vw;
  line-height: 1.25vw;
}
.productsList ul li:last-child {
  border: 0;
  padding-bottom: 0;
}
.productsList ul li:hover {
  background-color: #4f6ddb;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}

.add-prod-heading h2 {
  font-weight: 400;
  line-height: 2.08125vw;
  letter-spacing: -2%;
  font-size: 2.08125vw;
}

.add-prod-heading {
  margin-bottom: 1.11vw;
}

.new_product_data form {
  background-color: rgba(255, 255, 255, 0.8980392157);
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 2.775vw 4.44vw;
  /* to change arrow fill color, add %23 infront of hex color */
}
.new_product_data form .new-product-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: stretch;
}
.new_product_data form * {
  box-sizing: border-box;
}
.new_product_data form .product-3d-model-container:not(.product-music-container) {
  width: calc(100% - 5rem);
}
.new_product_data form .product-music-container {
  margin-bottom: 25px;
}
.new_product_data form .new-product-wrapper {
  grid-column: 1/2;
  grid-row: 1;
  width: calc(100% - 5rem);
}
.new_product_data form .new-product-wrapper select {
  width: 100%;
  appearance: none;
}
.new_product_data form .new-product-wrapper select {
  cursor: pointer;
}
.new_product_data form .productsList {
  cursor: default;
  z-index: 3;
}
.new_product_data form .new-product-wrapper .down-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2%;
}
.new_product_data form .new-product-wrapper select,
.new_product_data form .new-product-wrapper .productTitle {
  background-size: 0.754rem;
  background-position: calc(100% - 0.555vw) 1vw;
  background-repeat: no-repeat;
}
.new_product_data form .new-product-wrapper div,
.new_product_data form .new-product-wrapper input,
.new_product_data form .new-product-wrapper select {
  width: 100%;
}
.new_product_data form .productTitle::placeholder {
  position: relative;
  left: 1.11vw;
}
.new_product_data form .new-product-wrapper select {
  width: calc(100% + 1.11vw);
}
.new_product_data form .new-product-wrapper div {
  margin: 1.11vw 0;
}
.new_product_data form .product-3d-model {
  margin-top: 1.11vw;
}
.new_product_data form .variant-title {
  margin-top: 0 !important;
}
.new_product_data form .new-product-wrapper input,
.new_product_data form .new-product-wrapper select,
.new_product_data form .product_desc textarea {
  padding: 0.55vw;
  border-radius: 0.21vw;
  border: 1px solid var(--Grey, #737373);
}
.new_product_data form .new-product-wrapper input:focus,
.new_product_data form .new-product-wrapper select:focus,
.new_product_data form .product_desc textarea:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(238, 58, 36, 0.8);
}
.new_product_data form .product_desc,
.new_product_data form .product_desc textarea,
.new_product_data form .upload_3d_model {
  width: 100%;
}
.new_product_data form .upload_3d_model {
  border: 1px solid #ababab;
  border-style: dashed;
  padding: 0.2775vw 0.55vw;
}
.new_product_data form label,
.new_product_data form .product-label {
  display: block;
  margin-bottom: 2.5px;
  color: #3a3a3a;
  font-weight: 400;
  line-height: 1.25vw;
  font-size: 0.91vw;
  letter-spacing: 2%;
}
.new_product_data form .custom-drag-box {
  border-radius: 6px;
  padding: 5px 10px;
  position: relative;
  cursor: pointer;
}
.new_product_data form .custom-drag-box .custom-drag-box-title {
  font-family: Inter;
  font-size: 0.91vw;
  font-weight: 400;
  line-height: 0.7vw;
  letter-spacing: 0em;
  text-align: center;
  color: #ee3a24;
  text-decoration: underline;
}
.new_product_data form .custom-drag-box .custom-drag-box-title span {
  margin: 0 0.555vw;
}
.new_product_data form .custom-drag-box .custom-drag-box-subTitle {
  font-family: Inter;
  font-size: 0.8325vw;
  font-weight: 500;
  line-height: 1.25vw;
  letter-spacing: 2%;
  text-align: center;
  color: #616161;
  margin: 0.555vw 0;
}
.new_product_data form .save-btn {
  align-self: center;
  border-radius: 0.21vw;
}
.new_product_data form .save-btn button {
  background-color: #ee3a24;
  font-weight: 500;
  color: #fff;
  font-size: 0.91vw;
  line-height: 1.25vw;
  letter-spacing: 2%;
  padding: 0.7555vw 3.33vw;
}
.new_product_data .search-icon {
  position: absolute;
  top: 0.21vw;
  left: 0.2775vw;
  transform: translateY(25%);
}
.new_product_data .productsImage {
  border-radius: 0.21vw;
  border: 2px solid #fff;
  gap: 5px;
  display: flex;
  justify-content: center;
}
.new_product_data .productsImage .audio-container {
  position: relative;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
  border-radius: 10px;
  margin: 0px 15px;
}
.new_product_data .productsImage .audio-container .audio-controller {
  background-color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 3px;
  right: 3px;
  cursor: pointer;
}
.new_product_data .productsImage .container {
  width: max-content;
  padding: 0 8px;
  background-color: #fff;
  padding-bottom: 1px;
  position: relative;
  border: 2px solid;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  border-radius: 8px;
}
.new_product_data .productsImage .container:hover {
  background-color: #ececec;
}
.new_product_data .productsImage .container p {
  font-size: 0.8vw;
  text-align: center;
  margin: 8px auto;
  color: #3a3a3a;
  font-weight: 400;
}
.new_product_data .productsImage img {
  border-radius: 0.21vw;
  width: 100px !important;
  height: 100px !important;
}

.min_char {
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 1.25vw;
  color: #616161;
  text-align: right;
  position: relative;
  right: -0.97125vw;
}

.new_product_data .slider-container {
  min-height: 9.125vw;
  background: #ffffff;
  border-radius: 0.21vw;
  margin: 1.11vw 0;
  padding: 1.65vw 2.22vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  overflow: hidden;
}
.new_product_data .slider-container .slick-slider .slick-track,
.new_product_data .slider-container .slick-slider .slick-list {
  transform: translate3d(3.33vw, 0, 0);
}

.new_product_data .slick-slide {
  width: 130px;
}

.new_product_data .slick-slide.slick-cloned {
  display: none;
}

.new_product_data .slick-track {
  width: 100%;
}

.new_product_data .slick-prev::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 0.42vw;
}

.new_product_data .slick-next::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  padding: 6px;
}

.merchandise-Store-button {
  text-align: end;
}

.merchandise-Store-button button {
  font-weight: 500;
  background-color: #ee3a24;
  color: #fff;
  line-height: 1.25vw;
  font-size: 13px;
  padding: 0.5rem 2rem;
  border: none;
  border-radius: 0.21vw;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/AddProduct.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AACA;EACE,wBAAA;AAEF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAGF;AAFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAIJ;AAHI;EACE,YAAA;AAKN;;AADA;EACE,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;AAIF;;AAFA;EACE,kBAAA;AAKF;AAJE;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;AAMJ;AALI;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;AAON;AALM;EACE,SAAA;EACA,iBAAA;AAOR;AAJI;EACE,yBAAA;EAEA,WAAA;EACA,uCAAA;AAKN;;AADA;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAIF;;AAFA;EACE,qBAAA;AAKF;;AAFE;EAEE,mDAAA;EACA,qBAAA;EACA,+DAAA;EAEA,uBAAA;EAkDA,6DAAA;AA9CJ;AAFI;EACE,aAAA;EACA,qCAAA;EACA,oBAAA;AAIN;AAFI;EACE,sBAAA;AAIN;AAGI;EACE,wBAAA;AADN;AAGI;EACE,mBAAA;AADN;AAGI;EACE,gBAAA;EACA,WAAA;EACA,wBAAA;AADN;AAGI;EACE,WAAA;EAGA,gBAAA;AADN;AAGI;EACE,eAAA;AADN;AAGI;EACE,eAAA;EACA,UAAA;AADN;AAQI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;AANN;AASI;;EAEE,yBAAA;EACA,6CAAA;EACA,4BAAA;AAPN;AAUI;;;EAGE,WAAA;AARN;AAWI;EACE,kBAAA;EACA,YAAA;AATN;AAWI;EACE,0BAAA;AATN;AAWI;EACE,gBAAA;AATN;AAWI;EACE,kBAAA;AATN;AAWI;EACE,wBAAA;AATN;AAcI;;;EAGE,eAAA;EACA,qBAAA;EACA,sCAAA;AAZN;AAcI;;;EAGE,aAAA;EACA,gBAAA;EACA,wCAAA;AAZN;AAcI;;;EAGE,WAAA;AAZN;AAcI;EACE,yBAAA;EACA,oBAAA;EACA,wBAAA;AAZN;AAcI;;EAEE,cAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAZN;AAcI;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAbN;AAeI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAbN;AAeI;EACE,iBAAA;AAbN;AAeI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAbN;AAeI;EACE,kBAAA;EACA,qBAAA;AAbN;AAeI;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;AAbN;AAgBE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;AAdJ;AAgBE;EACE,qBAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;AAdJ;AAeI;EACE,kBAAA;EACA,uDAAA;EACA,mBAAA;EACA,gBAAA;AAbN;AAcM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AAZR;AAeI;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6GAAA;EAKA,kBAAA;AAjBN;AAkBM;EACE,yBAAA;AAhBR;AAkBM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAhBR;AAyBI;EACE,qBAAA;EACA,uBAAA;EACA,wBAAA;AAvBN;;AA2BA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAxBF;;AA0BA;EACE,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+DAAA;EACA,gBAAA;AAvBF;AAwBE;;EAEE,oCAAA;AAtBJ;;AAyBA;EACE,YAAA;AAtBF;;AAwBA;EACE,aAAA;AArBF;;AAwBA;EACE,WAAA;AArBF;;AAwBA;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,eAAA;AArBF;;AAwBA;EACE,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;AArBF;;AAwBA;EACE,eAAA;AArBF;;AAuBA;EACE,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AApBF","sourcesContent":[".spinner-loader {\n  display: flex;\n  width: 100%;\n  height: 75vh;\n  align-items: center;\n  justify-content: center;\n}\n.add-product-container * {\n  box-sizing: revert-layer;\n}\n.add-product-container .add-prod-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  p {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n    svg {\n      width: 0.7em;\n    }\n  }\n}\n.new_product_data form .new-product-wrapper .image-container {\n  margin: 0;\n  position: absolute;\n  transform: translateY(-12.5%);\n  left: -45px;\n  width: max-content;\n}\n.productsList {\n  position: relative;\n  ul {\n    width: 100%;\n    position: absolute;\n    display: block;\n    border: 1px solid;\n    border-radius: 4px;\n    padding: 0.7vw 0;\n    background: #fff;\n    top: -1.11vw;\n    left: 0;\n    max-height: 25vh;\n    overflow-y: scroll;\n    li {\n      padding: 2px 10px;\n      font-size: 0.8325vw;\n      line-height: 1.25vw;\n      // border-bottom: 1px solid;\n      &:last-child {\n        border: 0;\n        padding-bottom: 0;\n      }\n    }\n    li:hover {\n      background-color: #4f6ddb;\n      // background: rgba(0, 0, 0, 0.3);\n      color: #fff;\n      text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);\n    }\n  }\n}\n.add-prod-heading h2 {\n  font-weight: 400;\n  line-height: 2.08125vw;\n  letter-spacing: -2%;\n  font-size: 2.08125vw;\n}\n.add-prod-heading {\n  margin-bottom: 1.11vw;\n}\n.new_product_data {\n  form {\n    // margin-left: 2rem;\n    background-color: #ffffffe5;\n    border-radius: 0.21vw;\n    box-shadow: 0px 4px 7.4px 0px #bebebe40;\n\n    padding: 2.775vw 4.44vw;\n\n    .new-product-container {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      align-items: stretch;\n    }\n    & * {\n      box-sizing: border-box;\n    }\n    // .product-3d-model-container{\n    //   display: grid;\n    //   grid-template-columns: repeat(2, 1fr);\n    // align-items:center ;\n    // }\n    .product-3d-model-container:not(.product-music-container) {\n      width: calc(100% - 5rem);\n    }\n    .product-music-container {\n      margin-bottom: 25px;\n    }\n    .new-product-wrapper {\n      grid-column: 1 / 2;\n      grid-row: 1;\n      width: calc(100% - 5rem);\n    }\n    .new-product-wrapper select {\n      width: 100%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n    }\n    .new-product-wrapper select {\n      cursor: pointer;\n    }\n    .productsList {\n      cursor: default;\n      z-index: 3;\n    }\n    // .new-product-wrapper select, .new-product-wrapper .productTitle{\n    //     background: url(\"../../assests/svg/select-arrow.svg\") no-repeat;\n    //     background-color: #fff;\n    // }\n\n    .new-product-wrapper .down-arrow {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 2%;\n    }\n    /* to change arrow fill color, add %23 infront of hex color */\n    .new-product-wrapper select,\n    .new-product-wrapper .productTitle {\n      background-size: 0.754rem;\n      background-position: calc(100% - 0.555vw) 1vw;\n      background-repeat: no-repeat;\n    }\n\n    .new-product-wrapper div,\n    .new-product-wrapper input,\n    .new-product-wrapper select {\n      width: 100%;\n    }\n\n    .productTitle::placeholder {\n      position: relative;\n      left: 1.11vw;\n    }\n    .new-product-wrapper select {\n      width: calc(100% + 1.11vw);\n    }\n    .new-product-wrapper div {\n      margin: 1.11vw 0;\n    }\n    .product-3d-model {\n      margin-top: 1.11vw;\n    }\n    .variant-title {\n      margin-top: 0 !important;\n    }\n    // .new-product-wrapper:nth-child(1) input{\n    //   padding: 5px 5px 5px 24px;\n    // }\n    .new-product-wrapper input,\n    .new-product-wrapper select,\n    .product_desc textarea {\n      padding: 0.55vw;\n      border-radius: 0.21vw;\n      border: 1px solid var(--Grey, #737373);\n    }\n    .new-product-wrapper input:focus,\n    .new-product-wrapper select:focus,\n    .product_desc textarea:focus {\n      outline: none;\n      box-shadow: none;\n      border: 1px solid #ee3a24cc;\n    }\n    .product_desc,\n    .product_desc textarea,\n    .upload_3d_model {\n      width: 100%;\n    }\n    .upload_3d_model {\n      border: 1px solid #ababab;\n      border-style: dashed;\n      padding: 0.2775vw 0.55vw;\n    }\n    label,\n    .product-label {\n      display: block;\n      margin-bottom: 2.5px;\n      color: #3a3a3a;\n      font-weight: 400;\n      line-height: 1.25vw;\n      font-size: 0.91vw;\n      letter-spacing: 2%;\n    }\n    .custom-drag-box {\n      // background-color: #FAFAFA;\n      border-radius: 6px;\n      padding: 5px 10px;\n      position: relative;\n      cursor: pointer;\n    }\n    .custom-drag-box .custom-drag-box-title {\n      font-family: Inter;\n      font-size: 0.91vw;\n      font-weight: 400;\n      line-height: 0.7vw;\n      letter-spacing: 0em;\n      text-align: center;\n      color: #ee3a24;\n      text-decoration: underline;\n    }\n    .custom-drag-box .custom-drag-box-title span {\n      margin: 0 0.555vw;\n    }\n    .custom-drag-box .custom-drag-box-subTitle {\n      font-family: Inter;\n      font-size: 0.8325vw;\n      font-weight: 500;\n      line-height: 1.25vw;\n      letter-spacing: 2%;\n      text-align: center;\n      color: #616161;\n      margin: 0.555vw 0;\n    }\n    .save-btn {\n      align-self: center;\n      border-radius: 0.21vw;\n    }\n    .save-btn button {\n      background-color: #ee3a24;\n      font-weight: 500;\n      color: #fff;\n      font-size: 0.91vw;\n      line-height: 1.25vw;\n      letter-spacing: 2%;\n      padding: 0.7555vw 3.33vw;\n    }\n  }\n  .search-icon {\n    position: absolute;\n    top: 0.21vw;\n    left: 0.2775vw;\n    transform: translateY(25%);\n  }\n  .productsImage {\n    border-radius: 0.21vw;\n    border: 2px solid #fff;\n    gap: 5px;\n    display: flex;\n    justify-content: center;\n    .audio-container {\n      position: relative;\n      box-shadow: 0px 4px 4px 0px #00000040;\n      border-radius: 10px;\n      margin: 0px 15px;\n      .audio-controller {\n        background-color: #fff;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: absolute;\n        bottom: 3px;\n        right: 3px;\n        cursor: pointer;\n      }\n    }\n    .container {\n      width: max-content;\n      padding: 0 8px;\n      background-color: #fff;\n      padding-bottom: 1px;\n      position: relative;\n      border: 2px solid;\n      border-image-source: linear-gradient(\n        169.15deg,\n        rgba(255, 255, 255, 0.4) 0%,\n        rgba(238, 237, 237, 0.2) 96.79%\n      );\n      border-radius: 8px;\n      &:hover {\n        background-color: #ececec;\n      }\n      p {\n        font-size: 0.8vw;\n        text-align: center;\n        margin: 8px auto;\n        color: #3a3a3a;\n        font-weight: 400;\n      }\n    }\n    // span {\n    //   position: relative;\n    //   top: 0.75rem;\n    //   left: -1px;\n    //   cursor: pointer;\n    // }\n    img {\n      border-radius: 0.21vw;\n      width: 100px !important;\n      height: 100px !important;\n    }\n  }\n}\n.min_char {\n  font-size: 0.8325vw;\n  font-weight: 400;\n  line-height: 1.25vw;\n  color: #616161;\n  text-align: right;\n  position: relative;\n  right: -0.97125vw;\n}\n.new_product_data .slider-container {\n  min-height: 9.125vw;\n  background: #ffffff;\n  border-radius: 0.21vw;\n  margin: 1.11vw 0;\n  padding: 1.65vw 2.22vw;\n  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n  overflow: hidden;\n  .slick-slider .slick-track,\n  .slick-slider .slick-list {\n    transform: translate3d(3.33vw, 0, 0);\n  }\n}\n.new_product_data .slick-slide {\n  width: 130px;\n}\n.new_product_data .slick-slide.slick-cloned {\n  display: none;\n}\n\n.new_product_data .slick-track {\n  width: 100%;\n  // transform: translate3d(2.92vw, 0, 0) !important;\n}\n.new_product_data .slick-prev::before {\n  content: \"\";\n  background-image: url(\"../../../assets/svg/Previous.svg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  padding: 0.42vw;\n}\n\n.new_product_data .slick-next::before {\n  content: \"\";\n  background-image: url(\"../../../assets/svg/next.svg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  padding: 6px;\n}\n\n.merchandise-Store-button {\n  text-align: end;\n}\n.merchandise-Store-button button {\n  font-weight: 500;\n  background-color: #ee3a24;\n  color: #fff;\n  line-height: 1.25vw;\n  font-size: 13px;\n  padding: 0.5rem 2rem;\n  border: none;\n  border-radius: 0.21vw;\n  cursor: pointer;\n}\n// @media only screen  and  (max-width: 768px) {\n\n//   .new_product_data {\n//     form {\n//       margin-left: 0rem;\n//       padding: 2.5rem 2rem;\n\n//   .new-product-container{\n//     display: grid;\n//     grid-template-columns: repeat(1, 1fr);\n//   align-items: center;\n//   }\n//   .new-product-wrapper {\n//     grid-column: 1 / 1;\n//     grid-row: 1;\n//     width:100% ;\n//   }\n//   .new-product-wrapper div, .new-product-wrapper input, .new-product-wrapper select{\n//     width: 100%;\n\n//   }\n//   .new-product-wrapper input, .new-product-wrapper select{\n//     border: 1px solid  #737373;\n//     border-radius: 0.21vw;\n//   }\n//   .new-product-wrapper select{\n//     width: 100% ;\n//   }\n//   .save-btn{\n//     text-align: center;\n//    margin: 1rem 0;\n//   }\n// }\n//   }\n// }\n// @media only screen  and  (max-width:414px) {\n//   .merchandise-Store-button{\n//     text-align: center;\n//   }\n// }\n// @media only screen  and  (min-width: 769px) and  (max-width:900px) {\n\n//   .new_product_data {\n//     form {\n//       margin-left: 0rem;\n//       padding: 2.5rem;\n//     }\n//   }\n// }\n// @media only screen  and  (max-width: 900px) {\n//  .new_product_data .slider-container {\n//     margin: 1rem 0;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
